export default __webpack_public_path__ + "static/media/IMG-20240822-WA0023.4341926a.jpg";